import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  switchControlLabel: {
    marginLeft: '0 !important',
    paddingLeft: '0 !important',
    alignItems: 'center !important',
    justifyContent: 'start',
    width: 'auto',

    '& > span': {
      fontSize: '14px',
      fontStyle: 'normal',
      color: theme.palette.grey[600],
    },
  },
}));
